import axios from 'axios'
import store from '../store/index'

axios.defaults.timeout = 15 * 1000;

const configWithTokenId = async(_function) => {
    const reqHttp = await axios.create({
        baseURL: process.env.VUE_APP_BASE_API_V2,
        headers: {
            Authorization: await store.getters["user/userToken"], 
            "x-api-key": process.env.VUE_APP_X_API_KEY_V2
        }
    })
    return await _function(reqHttp)
}

const configNoHeaders = async(_function) => {
    const reqHttp = await axios.create({
        baseURL: process.env.VUE_APP_BASE_API,
        headers: { "x-api-key": process.env.VUE_APP_X_API_KEY }
    })
    return await _function(reqHttp)
}

const configNoHeadersV2 = async(_function) => {
    const reqHttp = await axios.create({
        baseURL: process.env.VUE_APP_BASE_API_V2,
        headers: { "x-api-key": process.env.VUE_APP_X_API_KEY_V2 }
    })
    return await _function(reqHttp)
}

export {
    configWithTokenId, 
    configNoHeaders ,
    configNoHeadersV2
}